<template>
  <div class="DataUpdate">
    <modal
      name="UpdateModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow:scroll"
    >
      <div id="tabs" class="container">
        <div class="tabs">
          <a
            v-on:click="activetab = 1"
            v-bind:class="[activetab === 1 ? 'active' : '']"
            >Datos Básicos</a
          >
          <!--<a
            v-on:click="activetab=2"
            v-bind:class="[ activetab === 2 ? 'active' : '' ]"
          >Centro de Transferencia</a>-->
        </div>
        <div class="content">
          <div v-if="activetab === 1" class="tabcontent">
            <ValidationObserver ref="obsFieldsUpdate">
              <FormUpdateClient
                :FieldsForm="formUpdate"
                :ModelForm="formUpdModel"
                :method="executeProcess"
                v-if="renderComponent2"
              />
            </ValidationObserver>
          </div>
          <div v-if="activetab === 2" class="tabcontent">
            <DataTransfer
              :InfoView="this.formUpdModel.CodTransferCenter"
              :HeadTable="this.HDTransfer"
              :method="executeProcess"
            />
          </div>
        </div>
        <div class="botoPnrocess">
          <div class="container">
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-2">
                <button
                  id="UpdateUser"
                  type="submit"
                  v-on:click="UpdateUser"
                  class="loginbtn primaryBtn"
                >
                  Actualizar
                </button>
              </div>
              <div class="col-md-2">
                <button
                  id="CancelUser"
                  type="submit"
                  v-on:click="CancelUser"
                  class="loginbtn primaryBtn"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="titlePage">ACTUALIZACION DE DATOS</div>
    <va-notification color="info" v-if="addRExito" class="refNoData"
      >Se actualizo correctamente el usuario solicitado.</va-notification
    >
    <va-notification color="danger" v-if="refNoUpdate" class="refNoData"
      >La actualizacion del usuario presento un fallo.</va-notification
    >
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData"
      >El servicio que ejecuta la actualización no se encuentra
      activo.</va-notification
    >

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchClient
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
        v-if="renderComponent3"
      />
    </ValidationObserver>
    <va-notification color="danger" id="refNoData" class="refNoData noShow"
      >No se encontró información del usuario solicitado.</va-notification
    >
    <div class="listClients">
      <DataTablePersons
        :InfoView="this.DLPersons"
        :HeadTable="this.HDPersons"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchClient from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormUpdateClient from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePersons from '@/components/data-tables/DataPersonsUpdate.vue'
import DataTransfer from '@/components/data-tables/DataTransfer.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePersons,
    FormSearchClient,
    FormUpdateClient,
    DataTransfer,
  },
  data () {
    return {
      activetab: 1,
      formSchModel: {
        CodeOperator: '',
        NumIdentify: '',
        IdBannerNum: '',
      },
      formAddModel: {
        IdAddressList: '',
        IdAddressStreet: '',
        IdAddressNumTxt: '',
        IdAddressNum: '',
        IdAddressRefTxt: '',
        IdAddressRef: '',
        IdAddressExtra: '',
      },
      formSearch: [
        {
          id: 'Sch_Document',
          model: 'NumIdentify',
          name: 'Documento de Identidad',
          type: 'input',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            min: 7,
            max: 15,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_IdBanner',
          model: 'IdBannerNum',
          name: 'Id Banner',
          type: 'input',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
            numeric: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'Sch_Operator',
          model: 'CodeOperator',
          name: 'Operador',
          type: 'Select',
          class: 'col-md-3',
          values: [],
          validate: {
            required: true,
          },
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar',
          class: 'col-md-3',
        },
      ],
      formUpdModel: {
        idUpdatedBy: this.$session.get('IberoJWTAdminLogin').idPerson,
        IdPerson: '',
        IdStatus: '',
        IdUsrName: '',
        IdDocType: '',
        IdDocTypeName: '',
        IdDocument: '',
        IdBanner: '',
        IdNombre: '',
        IdApellidos: '',
        IdAddress: '',
        IdMail: '',
        IdCelPhone: '',
        IdHomePhone: '',
        IdState: '',
        IdCity: '',
        IdFileDoc: '',
        IdTermiCondi: '',
        IdNewsLetter: '',
        IdObservaciones: '',
        CodTransferCenter: [],
      },
      formUpdate: [
        {
          id: 'IdDocTypeName',
          model: 'IdDocTypeName',
          name: 'Tipo de identificación',
          type: 'informative',
          placeholder: 'Tipo de identificación',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdDocument',
          model: 'IdDocument',
          name: 'Documento de Identidad',
          type: 'informative',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: false,
            max: 15,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdBanner',
          model: 'IdBanner',
          name: 'Id Banner',
          type: 'informative',
          placeholder: 'Id Banner',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdNombre',
          model: 'IdNombre',
          name: 'Nombres',
          type: 'input',
          placeholder: 'Nombres',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdApellidos',
          model: 'IdApellidos',
          name: 'Apellidos',
          type: 'input',
          placeholder: 'Apellidos',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdAddress',
          model: 'IdAddress',
          name: 'Dirección',
          type: 'input',
          placeholder: 'Dirección',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdMail',
          model: 'IdMail',
          name: 'Correo Electrónico Personal',
          type: 'input',
          placeholder: 'Correo Electrónico Personal',
          values: '',
          validate: {
            required: true,
            email: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdCelPhone',
          model: 'IdCelPhone',
          name: 'Teléfono Celular',
          type: 'input',
          placeholder: 'Teléfono Celular',
          values: '',
          validate: {
            required: true,
            numeric: true,
            max: 10,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdHomePhone',
          model: 'IdHomePhone',
          name: 'Teléfono Fijo',
          type: 'input',
          placeholder: 'Teléfono Fijo',
          values: '',
          validate: {
            required: false,
            numeric: true,
            max: 7,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdState',
          model: 'IdState',
          name: 'Departamento',
          type: 'Select',
          placeholder: 'Departamento',
          class: 'col-md-3',
          values: this.$store.state.StateList,
          validate: {
            required: true,
          },
        },
        {
          id: 'IdCity',
          model: 'IdCity',
          name: 'Ciudad',
          type: 'Select',
          placeholder: 'Ciudad',
          validate: {
            required: true,
          },
          class: 'col-md-3',
          values: this.$store.state.CityList,
        },

        {
          id: 'IdObservaciones',
          model: 'IdObservaciones',
          name: 'Observaciones',
          type: 'textarea',
          placeholder: '',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-12',
        },
        {
          id: 'IdNewsLetter',
          name: 'Informacion Comercial',
          model: 'IdNewsLetter',
          type: 'accepted',
          placeholder: 'Recibir informacion comercial',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6 linkref',
        },
      ],
      formAddress: [
        {
          id: 'IdAddressList',
          model: 'IdAddressList',
          type: 'Select2',
          values: this.$store.state.listAddress,
          placeholder: 'Dirección',
          validate: {
            required: true,
          },
          class: 'col-md-3',
        },
        {
          id: 'IdAddressStreet',
          model: 'IdAddressStreet',
          type: 'input',
          values: this.$store.state.listAddress,
          placeholder: 'Dirección',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressNumTxt',
          model: 'IdAddressNumTxt',
          type: 'html',
          values: '#',
          class: 'col-md-1',
        },
        {
          id: 'IdAddressNum',
          model: 'IdAddressNum',
          type: 'input',
          values: '',
          placeholder: '#',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressRefTxt',
          model: 'IdAddressRefTxt',
          type: 'html',
          values: '-',
          class: 'col-md-1',
        },
        {
          id: 'IdAddressRef',
          model: 'IdAddressRef',
          type: 'input',
          placeholder: '#',
          values: '',
          validate: {
            required: true,
            alpha_num: true,
            max: 4,
          },
          class: 'col-md-2',
        },
        {
          id: 'IdAddressExtra',
          model: 'IdAddressExtra',
          type: 'input',
          placeholder: 'Informacion adicional',
          values: '',
          validate: {
            max: 35,
          },
          class: 'col-md-11',
        },
      ],
      HDPersons: [
        {
          name: 'idBanner',
          title: 'Id Banner',
          width: '10%',
        },
        {
          name: 'nameDocument',
          title: 'Tipo Identificación',
          width: '20%',
        },
        {
          name: 'numDocument',
          title: 'Num Identificación',
          width: '20%',
        },
        {
          name: 'namPerson',
          title: 'Nombres',
          sortField: 'namPerson',
          width: '20%',
        },
        {
          name: 'lastNamePerson',
          title: 'Apellidos',
          sortField: 'lastNamePerson',
          width: '20%',
        },
        {
          name: '__slot:telefono',
          title: 'Celular',
          width: '10%',
        },
        {
          name: '__slot:status',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      HDTransfer: [
        {
          name: 'idPeriod',
          title: 'Programa',
          width: '20%',
        },
        {
          name: 'namOperator',
          title: 'Centro de Transferencia',
          width: '20%',
        },
        {
          name: 'desPeriod',
          title: 'Periodo',
          width: '10%',
        },
        {
          name: '__slot:sello',
          title: 'Sello F.',
          width: '10%',
        },
        {
          name: '__slot:editar',
          title: 'Editar',
          width: '30%',
        },
      ],
      DLPersons: [],
      SelectPerson: [],
      UpdateOperator: [],
      renderComponent1: false,
      renderComponent2: false,
      renderComponent3: false,
      addRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      UserAdminOperators: [],
    }
  },
  created: function () {
    if (this.$session.get('IberoJWTAdminLogin').idPerson !== undefined) {
      this.callLoadOperators()
    } else {
      this.$session.remove('IberoJWTAdminLogin')
      this.$router.push({ name: 'not-found-simple' })
    }
  },
  methods: {
    callLoadOperators () {
      this.renderComponent3 = false
      var linksData = IberoHelpers.getOperatorsByUser(
        this.$store,
        this.$session.get('IberoJWTAdminLogin').idPerson,
      )
      linksData.then(Response => {
        if (Response.data) {
          for (var i = 0; i < Response.data.length; i++) {
            this.formSearch[2].values.push(
              { id: Response.data[i].Hom_Banner, value: Response.data[i].Nam_Operator }
            )
          }
        }
        IberoHelpers.forceRerender3(this)
      })
    },
    UpdateUser () {
      this.limpiaref()
      if (this.activetab === 1) {
        return new Promise((resolve, reject) => {
          this.$refs.obsFieldsUpdate.validate().then(results => {
            if (!results) {
              resolve(false)
            } else {
              let loader = this.$loading.show()
              var totalinf = IberoHelpers.sendFormUpdate(
                this.$store,
                this.formUpdModel
              )
              totalinf.then(Response => {
                this.renderComponent1 = false
                if (Response === false) {
                  this.refWSUpdate = true
                  resolve(false)
                } else if (!(Response.status === 200)) {
                  this.refNoUpdate = true
                  resolve(false)
                } else {
                  this.addRExito = true
                  resolve(true)
                }
                this.$modal.hide('UpdateModal')
                this.searchForm()
                loader.hide()
              })
            }
          })
        })
      } else {
        let loader = this.$loading.show()
        var updateOperaPerson = IberoHelpers.sendFormUpdateOperator(
          this.$store,
          this.UpdateOperator
        )
        updateOperaPerson.then(Response => {
          this.renderComponent1 = false
          if (Response === false) {
            this.refWSUpdate = true
          } else if (!(Response.status === 200)) {
            this.refNoUpdate = true
          } else {
            this.addRExito = true
          }
          this.$modal.hide('UpdateModal')
          this.searchForm()
          loader.hide()
        })
      }
    },
    CancelUser () {
      this.limpiaref()
      this.$modal.hide('UpdateModal')
    },
    limpiaref () {
      this.addRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      let loader = this.$loading.show()
      var ListPersons = IberoHelpers.getPersonByOperatorList(
        this.$store,
        this.formSchModel
      )
      this.renderComponent1 = false
      ListPersons.then(Response => {
        if (Response.data === undefined || Response.data === '') {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPersons = Response.data
          } else {
            this.DLPersons = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'EditOperator':
          refer.IdBanner = this.formUpdModel.IdBanner
          refer.actPeriod = event.periodo
          this.UpdateOperator.push(refer)
          break
        case 'IdState':
          this.formUpdModel.IdCity = ''
          IberoHelpers.getCitiesListByState(
            this.$store.state.ApiIbero.WSParametric,
            this.$store.state.CityList,
            event.target.value
          )
          break
        case 'btn_Sch_Button':
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
      }
      this.$refs.obsFieldsSearch.validate()
    },
    processData: function (dataInf, refdata) {
      this.limpiaref()
      IberoHelpers.getCitiesListByState(
        this.$store.state.ApiIbero.WSParametric,
        this.$store.state.CityList,
        dataInf.codResidenceDepartment
      )
      this.formUpdModel.IdStatus = dataInf.staStatus
      this.formUpdModel.IdUsrName = dataInf.usrName
      this.formUpdModel.IdPerson = dataInf.idPerson
      this.formUpdModel.IdDocType = dataInf.idDocumentType
      this.formUpdModel.IdDocTypeName = IberoHelpers.dataObjFind(
        this.$store.state.DocTypesList,
        dataInf.idDocumentType
      )
      this.formUpdModel.IdDocument = dataInf.numDocument
      this.formUpdModel.IdBanner = dataInf.idBanner
      this.formUpdModel.IdNombre = dataInf.namPerson
      this.formUpdModel.IdApellidos = dataInf.lastNamePerson
      this.formUpdModel.IdAddress = dataInf.resAddress

      this.formUpdModel.IdHomePhone = ''
      this.formUpdModel.IdCelPhone = ''
      this.formUpdModel.IdMail = ''

      if (!(dataInf.information === undefined)) {
        for (var i = 0; i < dataInf.information.length; i++) {
          if (dataInf.information[i].idContactType === 1) {
            this.formUpdModel.IdHomePhone =
              dataInf.information[i].desContactInformation
          } else if (dataInf.information[i].idContactType === 2) {
            this.formUpdModel.IdCelPhone =
              dataInf.information[i].desContactInformation
          } else if (dataInf.information[i].idContactType === 3) {
            this.formUpdModel.IdMail =
              dataInf.information[i].desContactInformation
          }
        }
      }

      this.formUpdModel.IdState = dataInf.codResidenceDepartment
      this.formUpdModel.IdCity = dataInf.codResidenceCity
      this.formUpdModel.IdObservaciones = ''

      this.formUpdModel.IdTermiCondi = dataInf.termsConditions
      this.formUpdModel.IdNewsLetter = dataInf.infReceive
      this.formUpdModel.CodTransferCenter = dataInf.transferCenterModels

      IberoHelpers.forceRerender2(this)
      this.$modal.show('UpdateModal')
    },
  },
}
</script>

<style scoped>
.listClients {
  margin-top: 30px;
}

/* RESET */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* STYLING */
.container {
  max-width: 98%;
  min-width: 98%;
  margin: 10px auto;
  font-family: "Montserrat", sans-serif;
  color: #888;
}

/* Style the tabs */
.tabs {
  overflow: hidden;
  margin-left: 20px;
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 12px 24px;
  transition: background-color 0.2s;
  border: 1px solid #ccc;
  border-right: none;
  background-color: #f1f1f1;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}
.tabs a:last-child {
  border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #a2273c;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #a2273c;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  overflow-y: scroll;
  height: 500px;
}

.botoPnrocess {
  text-align: center;
  margin-top: -10px;
  margin-bottom: 30px;
}

.noShow {
  display: none;
}

.refNoData {
  font-weight: bold;
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
}

.listClients {
  padding: 20px;
}

.loginbtn {
  width: 90%;
}
</style>